import Cookies from "js-cookie";
import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { oat_driver_login } from "../../../networking/urlEndPoints";
import { authSelectedPharmacy } from "./authSelectedPharmacy";
import { clearLatestDriverPhotoUrl } from "../../slices/setting/driverProfilePhoto";
import { getCookieOptions } from "../../../utils/helper/security";

import * as routeNames from '../../../routes/routeName';
import * as Storage from '../../../storage/index'

export const authLogin = createAsyncThunk('authLogin', async (userDetail, { rejectWithValue }) => {

	const { email, passcode, password, navigate, dispatch } = userDetail

	try {

		const requesteData = {
			email: email,
			password: password,
			passcode: passcode
		}

		const response = await Axios.post(oat_driver_login, requesteData);
		const data = response.data;

		// A device may previously have been used by another driver. Never carry its
		// locally cached photo into this driver's session.
		dispatch?.(clearLatestDriverPhotoUrl());
		Cookies.set('authToken', data?.data?.token, getCookieOptions({ expiresHours: 11 }))
		Cookies.set('verified', 0, getCookieOptions())

		if (data?.data?.driver_pharmacy?.length === 1) {

			dispatch(authSelectedPharmacy(data?.data?.driver_pharmacy?.[0]))
			localStorage.removeItem(Storage.todayPendingRoute)
			localStorage.removeItem(Storage.todayMissedRoute)
			localStorage.removeItem(Storage.finalMissedRoute)

			if (typeof navigate === 'function') {
				navigate(routeNames.verify_otp)
			}

		}

		else {
			navigate(routeNames.SWITCH_PHARMACY)
		}

		return data;

	} catch (error) {
		return rejectWithValue(error.response)
	}
});
